module.exports = __webpack_public_path__ + "img/y_2024_hover.4bd44068.png";